import Popup from 'components/popup/Popup'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

import OopsMinion from 'assets/images/minions/OopsMinion.webp'
import CustomButton from 'components/custom-button/CustomButton'
import CustomImage from 'components/custom-image/CustomImage'
import { getClassNameForLanguage } from 'utils/common'
import { PATH_BILLING } from 'config/paths'

import './PlanLimitsPopup.scss'
import { data } from './data'

interface IProps {
    isShow: boolean
    setIsShow: () => void
}

const PlanLimitsPopup = ({ isShow, setIsShow }: IProps) => {
    const { t, i18n } = useTranslation(['featuresPopup'])
    const history = useHistory()

    const topPart = (
        <div className='plan-limits-popup__image'>
            <CustomImage src={OopsMinion} />
        </div>
    )

    const bodyPart = (
        <div className='plan-limits-popup__body'>
            <div
                className={`plan-limits-popup__body-title
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-bold',
                        eng: 'eng-bold',
                    })}`}
            >
                {t('featuresPopup:plan_limits_popup:title')}
            </div>
            <div
                className={`plan-limits-popup__body-subtitle
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-regular',
                        eng: 'eng-regular',
                    })}`}
            >
                {t('featuresPopup:plan_limits_popup:subtitle')}
            </div>
            <ul className='plan-limits-popup__body-ul'>
                {data.map(item => (
                    <>
                        <li
                            className={`plan-limits-popup__body-li
                             ${getClassNameForLanguage({
                                 i18n,
                                 uk: 'uk-bold',
                                 eng: 'eng-bold',
                             })}`}
                        >
                            {t(item.title)}
                        </li>
                        <div
                            className={`plan-limits-popup__body-liText
                             ${getClassNameForLanguage({
                                 i18n,
                                 uk: 'uk-regular',
                                 eng: 'eng-regular',
                             })}`}
                        >
                            {t(item.value, { amount: item.amount })}
                        </div>
                    </>
                ))}
            </ul>
            <div
                className={`plan-limits-popup__body-final-wrapper
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-regular',
                        eng: 'eng-regular',
                    })}`}
            >
                {t('featuresPopup:plan_limits_popup:unlock_more_features')}
            </div>
        </div>
    )

    const buttons = [
        <CustomButton
            key='buttonCanel'
            handleClick={() => {
                setIsShow()
            }}
            design='cancel'
            size='small'
        >
            {t('featuresPopup:plan_limits_popup:cancel')}
        </CustomButton>,
        <CustomButton
            key='buttonSubmit'
            handleClick={() => {
                history.push(PATH_BILLING.root)
                setIsShow()
            }}
            design='secondary'
            size='small'
        >
            {t('featuresPopup:plan_limits_popup:upgrade')}
        </CustomButton>,
    ]

    return (
        <>
            <Popup
                showPopup={isShow}
                setShowPopup={setIsShow}
                topDesign='straight'
                topPart={topPart}
                bodyPart={bodyPart}
                buttons={buttons}
                additionalClass='plan-limits-popup'
            />
        </>
    )
}

export default PlanLimitsPopup
